import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Bell, Smartphone } from "lucide-react";
import { api } from "@/lib/api";

const fmt = (s) => new Date(s).toLocaleString("it-IT", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export function BroadcastHistory({ reload }) {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/broadcasts").then(({ data }) => setItems(data.broadcasts)).catch(() => {});

  useEffect(() => {
    load();
    const t = setInterval(load, 8000);
    return () => clearInterval(t);
  }, [reload]);

  const stop = async (id) => {
    await api.put(`/admin/broadcasts/${id}/stop`);
    toast.success("Avviso tolto dall'app");
    load();
  };

  if (!items.length) return null;
  return (
    <div data-testid="bc-history">
      <p className="mb-2.5 font-semibold text-[#FAF9F6]">Messaggi inviati</p>
      <div className="space-y-2.5">
        {items.map((b) => (
          <div key={b.id} className="rounded-2xl border border-[#27272A] bg-[#121215] p-4" data-testid={`bc-item-${b.id}`}>
            <div className="flex items-start justify-between gap-2">
              <p className="font-semibold text-[#FAF9F6]">{b.title}</p>
              <span className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] ${b.kind === "promo" ? "bg-[#D4AF37]/15 text-[#E5C158]" : "bg-[#27272A] text-[#A1A1AA]"}`}>{b.kind === "promo" ? "Promo" : "Servizio"}</span>
            </div>
            <p className="mt-0.5 text-[12px] text-[#71717A]">{fmt(b.created_at)} · {b.audience_label} · {b.recipients} persone{b.status === "sending" && " · invio in corso…"}</p>
            <div className="mt-2 flex flex-wrap gap-3 text-[13px] text-[#A1A1AA]">
              {b.channels.includes("email") && <span className="inline-flex items-center gap-1"><Mail size={13} /> {b.email_sent} email{b.email_failed ? `, ${b.email_failed} non consegnate` : ""}</span>}
              {b.channels.includes("app") && <span className="inline-flex items-center gap-1"><Smartphone size={13} /> visto da {b.app_seen}</span>}
              {b.channels.includes("push") && <span className="inline-flex items-center gap-1"><Bell size={13} /> {b.push_sent} notifiche</span>}
            </div>
            {b.app_active && (
              <button onClick={() => stop(b.id)} data-testid={`bc-stop-${b.id}`} className="mt-2 text-[13px] text-[#FCA5A5] hover:text-[#F87171]">Togli l'avviso dall'app</button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
